import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <p>Thanks for stopping by! Now go get a coffee ☕</p>
    </footer>
  );
}

export default Footer;